import { render, staticRenderFns } from "./UploadFiles.vue?vue&type=template&id=c7989844"
import script from "./UploadFiles.vue?vue&type=script&lang=js"
export * from "./UploadFiles.vue?vue&type=script&lang=js"
import style0 from "./UploadFiles.vue?vue&type=style&index=0&id=c7989844&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports